/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function() {
  // Add custom code below this line
  



  function initGallery(root){
    if (!root || root.dataset.galleryInit === '1') return;

    const viewport = root.querySelector('[data-viewport]');
    const track = root.querySelector('[data-track]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const btnPrev = root.querySelector('[data-prev]');
    const btnNext = root.querySelector('[data-next]');

    if (!viewport || !track || slides.length === 0) return;

    root.dataset.galleryInit = '1';

    let index = 0;

    if (slides.length <= 1){
      if (btnPrev) btnPrev.style.display = 'none';
      if (btnNext) btnNext.style.display = 'none';
      return;
    }

    // ---------- Helpers ----------
    function slideStep(){
      const first = slides[0];
      if (!first) return viewport.clientWidth;
      const rect = first.getBoundingClientRect();

      // gap real calculado
      let gap = 0;
      if (slides[1]) {
        const r2 = slides[1].getBoundingClientRect();
        gap = Math.max(0, Math.round(r2.left - rect.right));
      }
      return Math.round(rect.width + gap);
    }

    function maxIndex(){
      const step = slideStep();
      const maxScroll = track.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 0) return 0;
      return Math.max(0, Math.round(maxScroll / step));
    }

    function apply(){
      const step = slideStep();
      const maxI = maxIndex();

      if (index < 0) index = 0;
      if (index > maxI) index = maxI;

      track.style.transition = 'transform .35s ease';
      track.style.transform = `translateX(${-index * step}px)`;

      if (btnPrev) btnPrev.disabled = index === 0;
      if (btnNext) btnNext.disabled = index === maxI;
    }

    function prev(){ index -= 1; apply(); }
    function next(){ index += 1; apply(); }

    if (btnPrev) btnPrev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); prev(); });
    if (btnNext) btnNext.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); next(); });

    window.addEventListener('resize', apply, { passive:true });

    // ---------- Swipe / drag (mobile) ----------
    // Usamos pointer events cuando están disponibles (incluye touch).
    // Si es mouse, no hacemos drag (para no interferir con clicks).
    let isDragging = false;
    let allowDrag = false;
    let startX = 0;
    let startTranslate = 0; // px
    let currentTranslate = 0; // px
    const THRESHOLD = 8;

    function getTranslateX(){
      const t = track.style.transform || '';
      const m = t.match(/translateX\(([-0-9.]+)px\)/);
      return m ? parseFloat(m[1]) : 0;
    }

    function setTranslateX(px){
      track.style.transform = `translateX(${px}px)`;
    }

    function clampTranslate(px){
      const step = slideStep();
      const maxI = maxIndex();
      const min = -maxI * step;
      const max = 0;
      if (px > max) return max;
      if (px < min) return min;
      return px;
    }

    function pointerDown(e){
      // Solo touch
      if (e.pointerType && e.pointerType !== 'touch') return;

      allowDrag = true;
      isDragging = false;

      startX = e.clientX;
      // partimos desde la posición real actual (por si resize cambió)
      startTranslate = getTranslateX();
      currentTranslate = startTranslate;

      track.style.transition = 'none';
    }

    function pointerMove(e){
      if (!allowDrag) return;

      const dx = e.clientX - startX;

      if (!isDragging && Math.abs(dx) > THRESHOLD) {
        isDragging = true;
      }

      if (isDragging) {
        const nextT = clampTranslate(startTranslate + dx);
        currentTranslate = nextT;
        setTranslateX(nextT);
        if (e.cancelable) e.preventDefault();
      }
    }

    function pointerUp(){
      if (!allowDrag) return;

      const step = slideStep();
      const maxI = maxIndex();

      // si no alcanzó a “arrastrar”, volvemos a la posición del índice actual
      if (!isDragging) {
        allowDrag = false;
        apply();
        return;
      }

      // snap al índice más cercano
      const raw = -currentTranslate / step;
      index = Math.round(raw);

      if (index < 0) index = 0;
      if (index > maxI) index = maxI;

      allowDrag = false;
      isDragging = false;

      apply();
    }

    // Evitar que el swipe dispare click accidental en links
    viewport.addEventListener('click', function(ev){
      if (isDragging) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    }, true);

    if (window.PointerEvent) {
      viewport.style.touchAction = viewport.style.touchAction || 'pan-y'; // permite scroll vertical
      viewport.addEventListener('pointerdown', pointerDown, { passive:true });
      viewport.addEventListener('pointermove', pointerMove, { passive:false });
      viewport.addEventListener('pointerup', pointerUp, { passive:true });
      viewport.addEventListener('pointercancel', pointerUp, { passive:true });
      viewport.addEventListener('pointerleave', pointerUp, { passive:true });
    } else {
      // fallback iOS viejo
      viewport.addEventListener('touchstart', function(e){
        const t = e.touches && e.touches[0];
        if (!t) return;
        allowDrag = true;
        isDragging = false;
        startX = t.clientX;
        startTranslate = getTranslateX();
        currentTranslate = startTranslate;
        track.style.transition = 'none';
      }, { passive:true });

      viewport.addEventListener('touchmove', function(e){
        if (!allowDrag) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = t.clientX - startX;

        if (!isDragging && Math.abs(dx) > THRESHOLD) isDragging = true;

        if (isDragging) {
          const nextT = clampTranslate(startTranslate + dx);
          currentTranslate = nextT;
          setTranslateX(nextT);
          if (e.cancelable) e.preventDefault();
        }
      }, { passive:false });

      viewport.addEventListener('touchend', pointerUp, { passive:true });
      viewport.addEventListener('touchcancel', pointerUp, { passive:true });
    }

    apply();
  }

  function scan(scope=document){
    scope.querySelectorAll('[data-pcard-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=>scan());
  } else {
    scan();
  }

  const mo = new MutationObserver((muts)=>{
    for (const m of muts){
      for (const node of m.addedNodes){
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('[data-pcard-gallery]') || node.querySelector?.('[data-pcard-gallery]')){
          scan(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});






  "use strict";

  const BTN_SEL = '[data-quick-add-variant][data-variant-id]';
  const HOLDER_SEL = '[data-quick-add-holder]';
  const FORM_CLASS = 'quick-add__variant-form';

  function ensureForm(holder) {
    let form = holder.querySelector(`form.${FORM_CLASS}`);
    if (form) return form;

    form = document.createElement('form');
    form.className = FORM_CLASS;
    form.method = 'post';
    form.action = (window.theme?.routes?.cart_add_url) || '/cart/add';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = '';

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';

    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.setAttribute('data-variant-submit', '');
    submit.style.display = 'none';

    form.appendChild(idInput);
    form.appendChild(qtyInput);
    form.appendChild(submit);

    holder.appendChild(form);
    return form;
  }

  function setVariant(form, variantId) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = String(variantId);
  }

  function dispatchThemeAdd(submitButton) {
    // IMPORTANTE: no abrir drawer manualmente, el tema lo hace.
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { button: submitButton }
      })
    );
  }

  function onClick(e) {
    const btn = e.target.closest(BTN_SEL);
    if (!btn) return;

    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    e.preventDefault();
    e.stopPropagation();

    const holder = btn.closest(HOLDER_SEL);
    if (!holder) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const form = ensureForm(holder);
    setVariant(form, variantId);

    const submit = form.querySelector('button[data-variant-submit]');
    if (!submit) return;

    // UI estado
    btn.classList.add('is-loading');
    btn.disabled = true;

    // Limpieza cuando tema responda
    const cleanup = () => {
      btn.classList.remove('is-loading');
      // si era soldout no lo re-habilites
      if (!btn.classList.contains('is-soldout')) btn.disabled = false;
      document.removeEventListener('theme:product:add', cleanup, true);
      document.removeEventListener('theme:product:add-error', cleanup, true);
    };
    document.addEventListener('theme:product:add', cleanup, true);
    document.addEventListener('theme:product:add-error', cleanup, true);

    dispatchThemeAdd(submit);
  }

  // Delegación
  document.addEventListener('click', onClick, true);



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.



  // Megamenu 

    const root = document.querySelector('[data-mm-attach]');
    if(!root) return;
  
    // Selectores fijos según tu header actual
    const navEl = document.querySelector('.header__menu');
    if(!navEl) return;
  
    const topLinks = Array.from(navEl.querySelectorAll('.navlink--toplevel'));
    const panels = Array.from(root.querySelectorAll('[data-mm-panel]'));
    const overlay = root.querySelector('[data-mm-overlay]');
  
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
    const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  
    const findPanelByTitle = (title) => {
      const t = norm(title);
      return panels.find(p => norm(p.getAttribute('data-mm-match-title')) === t);
    };
  
    const setTopFromNav = () => {
      const r = navEl.getBoundingClientRect();
      root.style.setProperty('--mm-top', r.bottom + 'px');
    };
  
    const closeAll = () => {
      panels.forEach(p => {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden','true');
      });
      if(overlay) overlay.hidden = true;
    };
  
  
    const mm51_initTabsIn = (scopeEl) => {
      if(!scopeEl) return;
  
      const wrappers = Array.from(scopeEl.querySelectorAll('[data-mm-tabs]'));
      if(!wrappers.length) return;
  
      wrappers.forEach((wrap) => {
        // evita doble init
        if(wrap.getAttribute('data-mm-tabs-bound') === 'true') return;
        wrap.setAttribute('data-mm-tabs-bound', 'true');
  
        const btns = Array.from(wrap.querySelectorAll('[data-mm-tab-btn]'));
        const tabPanels = Array.from(wrap.querySelectorAll('[data-mm-tab-panel]'));
        if(!btns.length || !tabPanels.length) return;
  
        const setActive = (key) => {
          btns.forEach((b) => {
            const isOn = b.getAttribute('data-mm-tab-btn') === key;
            b.classList.toggle('is-active', isOn);
            b.setAttribute('aria-selected', isOn ? 'true' : 'false');
          });
  
          tabPanels.forEach((p) => {
            const isOn = p.getAttribute('data-mm-tab-panel') === key;
            p.classList.toggle('is-active', isOn);
          });
        };
  
        const def =
          wrap.getAttribute('data-default-tab') ||
          (btns[0] ? btns[0].getAttribute('data-mm-tab-btn') : null);
  
        if(def) setActive(def);
  
        btns.forEach((btn) => {
          btn.addEventListener('click', () => {
            setActive(btn.getAttribute('data-mm-tab-btn'));
          });
        });
      });
    };
  
    // --- Colección → imagen (desde template collection.mm.liquid) ---
    const collectionDataCache = new Map();
  
    const getCollectionHandleFromUrl = (url) => {
      try {
        const u = new URL(url, window.location.origin);
        const m = u.pathname.match(/^\/collections\/([^\/?#]+)/i);
        return m ? m[1] : null;
      } catch (e) {
        return null;
      }
    };
  
    const fetchCollectionData = async (handle) => {
      if(collectionDataCache.has(handle)) return collectionDataCache.get(handle);
  
      const res = await fetch(`/collections/${handle}?view=mm`, { credentials: 'same-origin' });
      if(!res.ok) throw new Error('collection mm view not found');
      const data = await res.json();
      collectionDataCache.set(handle, data);
      return data;
    };
  
    const fillLeftFromTriggerHref = async (panel, href, title) => {
      const mainLink = panel.querySelector('[data-mm-main-link]');
      const mainCta  = panel.querySelector('[data-mm-main-cta]');
      const imgEl    = panel.querySelector('[data-mm-main-img]');
  
      if(mainLink) mainLink.href = href || '#';
      if(mainCta)  mainCta.href = href || '#';
      if(mainCta)  mainCta.textContent = 'Ir a la colección';
  
      if(!imgEl) return;
  
      imgEl.hidden = true;
      imgEl.removeAttribute('src');
      imgEl.alt = (title || '').trim();
  
      const handle = getCollectionHandleFromUrl(href || '');
      if(!handle) return; // si no es /collections/..., no mostramos imagen
  
      try {
        const data = await fetchCollectionData(handle);
        if(data && data.image) {
          imgEl.src = data.image;
          imgEl.hidden = false;
        }
      } catch(e) {
        // si falla, simplemente no mostramos imagen
      }
    };
  
    let closeTimer = null;
    const cancelClose = () => { clearTimeout(closeTimer); closeTimer = null; };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 120);
    };
  
    const openForTrigger = async (a) => {
      const title = a.querySelector('.navtext') ? a.querySelector('.navtext').textContent : a.textContent;
      const href = a.getAttribute('href') || '#';
  
      const panel = findPanelByTitle(title);
      if(!panel) { closeAll(); return; }
  
      closeAll();
      setTopFromNav();
  
      // título del panel
      const titleEl = panel.querySelector('[data-mm-title]');
      if(titleEl) titleEl.textContent = (title || '').trim();
  
      // rellena izquierda (link + imagen de colección si aplica)
      await fillLeftFromTriggerHref(panel, href, title);
  
      // inicializa tabs (solo dentro de este panel)
      mm51_initTabsIn(panel);
  
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden','false');
      if(overlay) overlay.hidden = false;
    };
  
    // binds
    topLinks.forEach(a => {
      if(a.getAttribute('data-mm-bound') === 'true') return;
      a.setAttribute('data-mm-bound', 'true');
  
      a.addEventListener('mouseenter', () => {
        if(!isDesktop()) return;
        cancelClose();
        openForTrigger(a);
      });
  
      a.addEventListener('focus', () => {
        if(!isDesktop()) return;
        cancelClose();
        openForTrigger(a);
      });
  
      a.addEventListener('mouseleave', () => {
        if(!isDesktop()) return;
        scheduleClose();
      });
    });
  
    panels.forEach(p => {
      p.addEventListener('mouseenter', () => { if(!isDesktop()) return; cancelClose(); });
      p.addEventListener('mouseleave', () => { if(!isDesktop()) return; scheduleClose(); });
    });
  
    navEl.addEventListener('mouseleave', () => { if(!isDesktop()) return; scheduleClose(); });
    if(overlay) overlay.addEventListener('click', closeAll);
  
    document.addEventListener('keydown', (e) => { if(e.key === 'Escape') closeAll(); });
  
    window.addEventListener('resize', () => {
      if(!isDesktop()) closeAll();
      setTopFromNav();
    }, { passive: true });
  
    window.addEventListener('scroll', () => {
      if(!isDesktop()) return;
      setTopFromNav();
    }, { passive: true });
  
    setTopFromNav();

})();
document.addEventListener('DOMContentLoaded', function() {
  const btn = document.getElementById('btn-guia-tallas');
  const modal = document.getElementById('modal-guia-tallas');
  const close = document.querySelector('.close-guia');

  if(btn){
    btn.addEventListener('click', () => modal.style.display = 'block');
    close.addEventListener('click', () => modal.style.display = 'none');
    window.addEventListener('click', (e) => {
      if(e.target == modal) modal.style.display = 'none';
    });
  }
});